import { composeIO } from 'react-compose-io'
import { modalTipoLancamentoParceiroIO } from './ModalTipoLancamentoParceiro.IO'
import ModalTipoLancamentoParceiroView from './ModalTipoLancamentoParceiro.View'

export const ModalTipoLancamentoParceiro = composeIO(ModalTipoLancamentoParceiroView, modalTipoLancamentoParceiroIO)
